import { MARKS } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import Markdown from '#src/components/MarkdownWithHtml';

import styles from './styles.module.scss';

const options = {
  renderMark: {
    [MARKS.BOLD]: (text) => <span className={styles.bold}>{text}</span>,
  },
};

// Note: Since we remove Contentful in WBRT-5444, all richtext fields are now going
// to be html strings so user MarkdownWithHtml to handle it.
export const RichText = ({ text }) =>
  typeof text === 'string' ? (
    <Markdown>{text}</Markdown>
  ) : (
    documentToReactComponents(text, options)
  );
